import './App.css';
import RoutesApp from './routes';
import 'bootstrap/dist/css/bootstrap.min.css';



function App() {
  return (
    <div className="App">
      <RoutesApp/>
    </div>
  );
}

export default App;
